// extracted by mini-css-extract-plugin
export var standaloneTable = "_f2-0";
export var withExtraHeader = "_f2-1";